// node_modules
import { FC } from "react";
// Components
import { AsynchronousWrapper } from "Components";
// Custom hooks
import { useFetch } from "Hooks";
// Types
import { TTechnology, TUseFetch } from "Types";

type TTechnologyModalContentProps = {
    technologyId: string
}

export const TechnologyModalContent: FC<TTechnologyModalContentProps> = ({technologyId}: TTechnologyModalContentProps) => {
    // We use `useFetch` custom hook here
    // to fetch data from the server
    let { isLoading, didError, errorMessage, fetchedData }: TUseFetch<TTechnology> = useFetch(`api/technologies/${technologyId}/description`);

    return (
        <AsynchronousWrapper didError={didError} errorMessage={errorMessage} isLoading={isLoading} LoaderComponent={null}>
            {fetchedData ?
                <div>
                    <h1>{fetchedData.numbering} {fetchedData.name}</h1>
                    <div>{fetchedData.description}</div>
                </div>
                :
                <></>
            }
        </AsynchronousWrapper>
    );
}
